import Modal from "@/components/common/modal";
import type { ApprovalGroupType } from "@/types/entities/approval-groups";
import { Button, Icon } from "@elaniintc/goes-design-system";

interface Props {
  userId?: string;
  groups: ApprovalGroupType[];
  onClose?: () => void;
}

const UserLeaderInGroupModal = ({ userId, groups, onClose }: Props) => {
  const userGroups = groups.filter((g) =>
    g.members.some((m) => m.id === userId && m.seniority === 1),
  );

  const detailsText = (() => {
    switch (userGroups.length) {
      case 1:
        return ["un grupo", "este grupo"];
      case 2:
        return ["dos grupos", "estos dos grupos"];
      case 3:
        return ["tres grupos", "estos tres grupos"];
      default:
        return ["varios grupos", "todos estos grupos"];
    }
  })();

  return (
    <Modal
      isOpen
      onClose={() => {}}
      title="No es posible desactivar"
      modalContentClassName="max-w-[var(--size-horizontal-sm)] p-modal-md"
    >
      <p className="text-body text-center">
        Este usuario es líder en {detailsText[0]}. Necesitas cambiar el líder de{" "}
        {detailsText[1]} para poder desactivarlo:
      </p>
      <div className="flex flex-wrap gap-1 pt-[34px] pb-8">
        {userGroups.map((group) => {
          return (
            <div
              key={group.id}
              className="rounded-lg bg-surface-info-accent-quiet text-info px-2 flex gap-2.5 w-fit items-center"
            >
              <Icon name="users-rectangle" type="far" />
              <p className="leading-3xl">{group.name}</p>
            </div>
          );
        })}
      </div>
      <div>
        <Button
          size="lg"
          variant="tertiary"
          className="w-full"
          type="button"
          onClick={onClose}
        >
          Aceptar
        </Button>
      </div>
    </Modal>
  );
};

export default UserLeaderInGroupModal;
